<template>
  <form @submit.prevent="verify">
    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6 c-primary" icon="UsersIcon" class="mr-2" />
        <span class="font-medium text-lg pt-4 leading-none">I dati di seguito devono essere relativi <b>solo all'unità operativa del tirocinio</b></span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-4/12 w-full px-2">
        <vs-input-number v-if="!is_readonly" :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_addetti" label="Addetti totali:"/>
        <div v-if="is_readonly" class="vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Addetti totali:',form.num_addetti].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Escluso Apprendisti">
          <vs-input-number :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_addetti_ind" label="A tempo indeterminato:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="mt-5 vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['A tempo indeterminato:',form.num_addetti_ind].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Con data inizio contratto precedente l'avvio
          del presente tirocinio e data fine contratto successiva al termine del presente tirocinio">
          <vs-input-number :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_addetti_det" label="A tempo determinato:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="mt-5 vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['A tempo determinato:',form.num_addetti_det].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <vs-input-number v-if="!is_readonly" class="mt-5" :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_soci" label="Soci/Collaboratori:"/>
        <div v-if="is_readonly" class="mt-5 vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Soci/Collaboratori:',form.num_soci].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Escluso il presente">
          <vs-input-number class="mt-5" :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_ospitanti" label="Tirocinanti ospitati:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="mt-5 vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Tirocinanti ospitati:',form.num_ospitanti].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Con contratto di lavoro subordinato di almeno 6 mesi nei 24 mesi precedenti (attivati dopo il 01/07/2019)">
          <vs-input-number class="mt-5" :disabled="is_readonly" :min="0" :max="1000" v-model="form.num_assunti" label="Tirocinanti assunti:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="mt-5 vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Tirocinanti assunti:',form.num_assunti].join(' ')}}</span>
        </div>
      </vs-col>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6 c-primary" icon="BellIcon" class="mr-2" />
        <span class="font-medium text-lg pt-4 leading-none">Le date di attivazione sono vincolate dalle <b>tempistiche previste dalla normativa regionale</b></span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Inizio tirocinio:</label>
        <vx-input-group class="mb-base">
          <datepicker typeable placeholder="Data Inizio" :language="languages['it']" :format="datepicker_format" :disabled="is_readonly" v-model="form.data_inizio"></datepicker>
          <!-- <v-date :disabled="is_readonly" placeholder="Data Fine" :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.data_fine"/> -->
          <template v-if="form.data_inizio && !is_readonly" slot="append">
            <div class="append-text btn-addon">
              <vs-button @click="clearDateIn($event)" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Fine tirocinio:</label>
        <vx-input-group class="mb-base">
          <datepicker typeable :disabled-dates="{to: new Date(form.data_inizio)}" placeholder="Data fine" :language="languages['it']" :format="datepicker_format" :disabled="is_readonly" v-model="form.data_fine"></datepicker>
          <!-- <v-date :disabled="is_readonly" placeholder="Data Fine" :language="$date_lang" :monday-first="true" format="d MMM yyyy" v-model="form.data_fine"/> -->
          <template v-if="form.data_fine && !is_readonly" slot="append">
            <div class="append-text btn-addon">
              <vs-button @click="clearDateFine($event)" color="danger" type="border" icon-pack="feather" icon="icon-x"></vs-button>
            </div>
          </template>
        </vx-input-group>
      </vs-col>
      <vs-col class="md:w-4/12 w-full px-2">
        <label class="vs-input--label">Devono essere sempre svolte in affiancamento al tutor aziendale</label>
        <vs-checkbox class="mt-2" :disabled="is_readonly" v-model="form.trasferte">
          Trasferte
        </vs-checkbox>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Minimo 2 mesi - Massimo 6 mesi">
          <vs-input-number :disabled="is_readonly" :min="2" :max="6" v-model="form.num_mesi" label="Durata tirocinio:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Durata tirocinio:',form.num_mesi].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Massimo 6 giorni">
          <vs-input-number :disabled="is_readonly" :min="1" :max="6" v-model="form.week_days" label="Giornate Settimanali:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Giornate Settimanali:',form.week_days].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Massimo 40 ore">
          <vs-input-number :disabled="is_readonly" :min="1" :max="40" v-model="form.week_hours" label="Ore Settimanali:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Ore Settimanali:',form.week_hours].join(' ')}}</span>
        </div>
      </vs-col>
      <vs-col class="md:w-3/12 w-full px-2">
        <vx-tooltip v-if="!is_readonly" text="Massimo 26 giorni">
          <vs-input-number :disabled="is_readonly" :min="1" :max="26" v-model="form.month_days" label="Giornate Mensili:"/>
        </vx-tooltip>
        <div v-if="is_readonly" class="vs-input-number vs-input-number-size-null vs-input-number-primary">
          <span>{{['Giornate Mensili:',form.month_days].join(' ')}}</span>
        </div>
      </vs-col>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6 c-primary" icon="ClockIcon" class="mr-2" />
        <span class="font-medium text-lg pt-4 leading-none">Orari giornalieri di svolgimento tirocinio</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-row>
        <vs-col class="md:w-6/12 w-full px-2">
          <vs-col class="md:w-2/12 w-full px-2">
            <label class="text-lg"><b>Mattina</b></label>
          </vs-col>
          <vs-col class="md:w-5/12 w-full px-2">
            <!-- <label class="vs-input--label mr-2">Dalle</label> -->
            <vs-input :disabled="is_readonly" label="Dalle" class="w-full" v-model="form.mattina_da" type="time" min="00:00" max="13:00" step="900"/>
            <!-- <vue-timepicker :disabled="is_readonly" v-model="form.mattina_da" hide-disabled-hours close-on-complete :hour-range="[[0,13]]" :minute-interval="15"></vue-timepicker> -->
          </vs-col>
          <vs-col class="md:w-5/12 w-full px-2">
            <vs-input :disabled="is_readonly" label="Alle" class="w-full" v-model="form.mattina_a" type="time" min="00:00" max="13:00"/>
            <!-- <label class="vs-input--label mr-2">Alle</label>
            <vue-timepicker :disabled="is_readonly" v-model="form.mattina_a" hide-disabled-hours close-on-complete :hour-range="[[0,13]]" :minute-interval="15"></vue-timepicker> -->
          </vs-col>
        </vs-col>
        <vs-col class="md:w-6/12 w-full px-2">
          <vs-col class="md:w-2/12 w-full px-2">
            <label class="text-lg"><b>Pomeriggio</b></label>
          </vs-col>
          <vs-col class="md:w-5/12 w-full px-2">
            <vs-input :disabled="is_readonly" label="Dalle" class="w-full" v-model="form.pomeriggio_da" type="time" min="13:00" max="23:00"/>
            <!-- <label class="vs-input--label mr-2">Dalle</label>
            <vue-timepicker :disabled="is_readonly" v-model="form.pomeriggio_da" hide-disabled-hours close-on-complete :hour-range="[[13,23]]" :minute-interval="15"></vue-timepicker> -->
          </vs-col>
          <vs-col class="md:w-5/12 w-full px-2">
            <vs-input :disabled="is_readonly" label="Alle" class="w-full" v-model="form.pomeriggio_a" type="time" min="13:00" max="23:00"/>
            <!-- <label class="vs-input--label mr-2">Alle</label>
            <vue-timepicker :disabled="is_readonly" v-model="form.pomeriggio_a" hide-disabled-hours close-on-complete :hour-range="[[13,23]]" :minute-interval="15"></vue-timepicker> -->
          </vs-col>
        </vs-col>
      </vs-row>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3 mt-4">
        <feather-icon svgClasses="w-6 h-6 c-primary" icon="AnchorIcon" class="mr-2" />
        <span class="font-medium text-lg pt-4 leading-none">Periodo chiusura azienda (se previsto)</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row class="mb-6">
      <vs-col class="md:w-6/12 w-full px-2">
        <vs-col class="md:w-6/12 w-full px-2">
          <vx-tooltip text="Almeno 15 giorni di calendario">
            <label class="vs-input--label">Chiuso dal:</label>
            <vx-input-group class="mb-base">
              <datepicker typeable placeholder="Data chiusura" :language="languages['it']" :format="datepicker_format" :disabled="is_readonly" v-model="form.chiusura_inizio">
                <span v-if="form.chiusura_inizio && !is_readonly" slot="afterDateInput" class="animated-placeholder">
                  <vs-button @click="clearDateInAz($event)" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="w-full"></vs-button>
                </span>
              </datepicker>
            </vx-input-group>
          </vx-tooltip>
        </vs-col>
        <vs-col class="md:w-6/12 w-full px-2">
          <label class="vs-input--label">Fine chiusura:</label>
          <vx-input-group class="mb-base">
            <datepicker typeable placeholder="Data riapertura" :language="languages['it']" :format="datepicker_format" :disabled="is_readonly" v-model="form.chiusura_fine">
              <span v-if="form.chiusura_fine && !is_readonly" slot="afterDateInput" class="animated-placeholder">
                <vs-button @click="clearDateFineAz($event)" color="danger" type="flat" icon-pack="feather" icon="icon-x" class="w-full"></vs-button>
              </span>
            </datepicker>
          </vx-input-group>
        </vs-col>
      </vs-col>
      <vs-col class="md:w-6/12 w-full px-2">
        <vs-col class="md:w-6/12 w-full px-2">
          <vx-tooltip text="Non inferiore a € 450 netti">
            <vs-input :disabled="is_readonly" v-currency="{}" label="Indennità mensile per tirocinante" class="w-full" v-model="form.indennita"/>
          </vx-tooltip>
        </vs-col>
        <vs-col class="md:w-6/12 w-full px-2 mt-2">
          <ul class="demo-alignment">
            <li>
              <vs-radio :disabled="is_readonly" v-model="form.indennita_tipo" vs-value="netti">Netti</vs-radio>
            </li>
            <li>
              <vs-radio :disabled="is_readonly" v-model="form.indennita_tipo" vs-value="lordi">Lordi</vs-radio>
            </li>
          </ul>
        </vs-col>
      </vs-col>
    </vs-row>

    <vs-row>
      <div class="flex items-end px-3">
        <feather-icon svgClasses="w-6 h-6 c-primary" icon="AwardIcon" class="mr-2" />
        <span class="font-medium text-lg pt-4 leading-none">Attività formativa del tirocinante</span>
      </div>
      <vs-divider />
    </vs-row>
    <vs-row>
      <vs-col class="md:w-12/12 w-full px-2 mb-2">
        <ul class="demo-alignment">
          <vx-tooltip text="Clicca qui per cercare le unità di competenza per il tuo tirocinante">
            <label class="text-lg mt-6 mr-6"><a href="#" @click.prevent="openWindow()">Unità di competenza</a> </label>
          </vx-tooltip>
          <li>
            <vs-checkbox :disabled="is_readonly" v-model="form.uc1">UC1</vs-checkbox>
          </li>
          <li>
            <vs-checkbox :disabled="is_readonly" v-model="form.uc2">UC2</vs-checkbox>
          </li>
          <li>
            <vs-checkbox :disabled="is_readonly" v-model="form.uc3">UC3</vs-checkbox>
          </li>
          <li>
            <vs-checkbox :disabled="is_readonly" v-model="form.uc4">UC4</vs-checkbox>
          </li>
        </ul>
      </vs-col>
      <vs-col class="md:w-6/12 w-full px-2 mb-2">
        <label class="vs-input--label">Qualifica regionale di riferimento (SRQ)</label>
        <vs-input v-model="form.srq" :disabled="is_readonly" class="w-full"/>
      </vs-col>
      <vs-col class="md:w-6/12 w-full px-2">
        <label class="vs-input--label">Inserisci il reparto/ufficio/area di svolgimento del tirocinio</label>
          <vs-input :disabled="is_readonly" class="w-full" v-model="form.reparto_svolgimento"/>
      </vs-col>
      <vs-col class="md:w-12/12 w-full px-2">
        <label class="vs-input--label">Descrivi l'attività che svolgerà il tirocinante</label>
        <vs-textarea :disabled="is_readonly" class="w-full" v-model="form.attivita_svolta"/>
      </vs-col>
    </vs-row>
    <div v-if="!is_readonly" v-show="mostra_uc" class="iframe-thing">
      <vs-button color="danger" type="filled" @click="mostra_uc = false">Chiudi</vs-button>
      <iframe src="https://orienter.regione.emilia-romagna.it/qualifica/cerca"></iframe>
    </div>
  </form>
</template>

<script>

import flatPickr from 'vue-flatpickr-component'
import 'flatpickr/dist/flatpickr.css'
import Datepicker from '@sum.cumo/vue-datepicker';
import '@sum.cumo/vue-datepicker/dist/vuejs-datepicker.css'
import * as lang from 'vuejs-datepicker/src/locale';
import VueTimepicker from 'vue2-timepicker'

export default {
  props: ['form','is_readonly'],
  components: {
    flatPickr,
    Datepicker,
    VueTimepicker
  },

  data () {
    return {
      is_saving: false,
      mostra_uc: false,
      time: null,
      configdateTimePicker: {
        enableTime: true,
        enableSeconds: false,
        noCalendar: true
      },

      datepicker_format: "d.MM.yyyy",
      languages: lang,
    }
  },

  computed: {
    az () {
      return this.form.azienda
    },
  },

  mounted() {
    // if (!this.form) {
    //   this['form'] = {}
    // }
    if (!this.form.num_addetti) {
      this.form['num_addetti'] = 0
      this.form['num_addetti_det'] = 0
      this.form['num_addetti_ind'] = 0
      this.form['num_assunti'] = 0
      this.form['num_ospitanti'] = 0
      this.form['num_soci'] = 0
      this.form['num_mesi'] = 2
      this.form['month_days'] = 1
      this.form['week_days'] = 1
      this.form['week_hours'] = 1
    }
    // this.formatOrarioPicker()
  },

  methods: {
    save() {
      this.is_saving = true
      // console.log(this.form.indennita,'diventaaaaa',this.$parseCurrency(this.form.indennita));
      // console.log(this.form.mattina_da,'MATTINAnDA',this.form.mattina_a);
      this.$http.post(`modulo-tirocinio/salva?token=${this.form.token}`, this.form).then(res => {
        this.$parent.$parent.nextTab()
      }).finally(res => {
        this.is_saving = false
      })
    },
    clearDateIn(ev) {
      this.form.data_inizio = null
      ev.stopPropagation()
    },
    clearDateFine(ev) {
      this.form.data_fine = null
      ev.stopPropagation()
    },
    clearDateInAz(ev) {
      this.form.chiusura_inizio = null
      ev.stopPropagation()
    },
    clearDateFineAz(ev) {
      this.form.chiusura_fine = null
      ev.stopPropagation()
    },
    openWindow() {
      window.open("https://orienter.regione.emilia-romagna.it/qualifica/cerca", "_blank");
    },
    formatOrarioPicker() {
      let repeat = ""
      let str = ""
      if(this.form.mattina_da_ora || this.form.mattina_da_min) {
        repeat = this.form.mattina_da_ora.toString()
        str = repeat.length > 1 ? repeat : ["0",repeat].join("")
        this.form['mattina_da'] = {HH: str, mm: ''+this.form.mattina_da_min}
      }
      if(this.form.mattina_a_ora || this.form.mattina_a_min) {
        repeat = this.form.mattina_a_ora.toString()
        str = repeat.length > 1 ? repeat : ["0",repeat].join("")
        this.form['mattina_a'] = {HH: str, mm: ''+this.form.mattina_a_min}
      }
      if(this.form.pomeriggio_da_ora || this.form.pomeriggio_da_min) {
        repeat = this.form.pomeriggio_da_ora.toString()
        str = repeat.length > 1 ? repeat : ["0",repeat].join("")
        this.form['pomeriggio_da'] = {HH: str, mm: ''+this.form.pomeriggio_da_min}
      }
      if(this.form.pomeriggio_a_ora || this.form.pomeriggio_a_min) {
        repeat = this.form.pomeriggio_a_ora.toString()
        str = repeat.length > 1 ? repeat : ["0",repeat].join("")
        this.form['pomeriggio_a'] = {HH: str, mm: ''+this.form.pomeriggio_a_min}
      }
    }
  },

  watch: {
    'form.mattina_da_ora'(v) {
      let ok = Math.min(23, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.mattina_da_ora = ok
    },
    'form.mattina_a_ora'(v) {
      let ok = Math.min(23, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.mattina_a_ora = ok
    },
    'form.pomeriggio_da_ora'(v) {
      let ok = Math.min(23, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.pomeriggio_da_ora = ok
    },
    'form.pomeriggio_a_ora'(v) {
      let ok = Math.min(23, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.pomeriggio_a_ora = ok
    },
    'form.mattina_da_min'(v) {
      let ok = Math.min(59, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.mattina_da_min = ok
    },
    'form.mattina_a_min'(v) {
      let ok = Math.min(59, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.mattina_a_min = ok
    },
    'form.pomeriggio_da_min'(v) {
      let ok = Math.min(59, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.pomeriggio_da_min = ok
    },
    'form.pomeriggio_a_min'(v) {
      let ok = Math.min(59, Math.max(0, v))
      if (isNaN(ok)) ok = ''
      if (v !== ok) this.form.pomeriggio_a_min = ok
    },
  }
}
</script>

<style lang="scss">
.modulo-tirocinio {
  .hour-picker {
    display: flex;
    flex-direction: row;
    margin: 0 0 8px;
    margin-left: 10px;
    font-size: .9rem;
    line-height: 2;

    .vs-component {
      margin: 0 2px;
      width: 1.8rem;
      input {
        font-size: .9rem;
        border-radius: 4px;
        padding: 3px!important;
        text-align: center;
      }

      input::-webkit-outer-spin-button,
      input::-webkit-inner-spin-button {
        -webkit-appearance: none;
        margin: 0;
      }

      /* Firefox */
      input[type=number] {
        -moz-appearance: textfield;
      }
    }
  }
  .iframe-thing {
    position: fixed;
    z-index: 100;
    top: 5%;
    bottom: 5%;
    left: 5%;
    right: 5%;
    box-shadow: 0 0 20px rgba(0,0,0,1);
    padding: 10px;
    border-radius: 20px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    background: #fff;
    border: 1px solid #000;
    .vs-button {
      // border-radius: 0!important;
      margin-bottom: 20px;
    }
    iframe {
      width: 100%;
      flex-grow: 1;
      border: 4px solid #fff;
    }
  }
}
</style>
